import Wrapper from "../../../layout/Wrapper";
import AppContentManageComponent from "../../../screens/settings/app-control/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "App Control Manage",
	description: "",
};

export default function AppControlManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<AppContentManageComponent />
		</Wrapper>
	);
}